import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApiKey } from '../context/ApiKeyContext';
import ApiKeyInput from '../components/ApiKeyInput';
import OutOfCreditsCard from '../components/OutOfCreditsCard';
import GenderSelection from '../components/GenderSelection';
import Layout from '../components/Layout';

const HomePage = () => {
  const { isKeyValid, trialMode, trialBlock } = useApiKey();
  const navigate = useNavigate();

  // Can the user actually enter the app? Either they've saved their own key, or
  // they're in an active trial that hasn't been blocked.
  const trialActive = trialMode && trialBlock !== 'trial_exhausted' && trialBlock !== 'owner_out_of_credits';
  const canPractice = isKeyValid || trialActive;

  // Picking a gender advances to the mode step, which is its own route so the
  // browser back button walks back here. The gender travels in the URL so the
  // later steps survive a refresh / direct link.
  const handleSelectGender = (gender) => {
    navigate(`/mode?gender=${gender}`);
  };

  const renderEntry = () => {
    if (trialBlock === 'owner_out_of_credits') {
      return <OutOfCreditsCard />;
    }
    if (!canPractice) {
      const notice = trialBlock === 'trial_exhausted'
        ? "You've used your 2 free chats. Enter your own Anthropic API key to keep practicing."
        : undefined;
      return <ApiKeyInput notice={notice} />;
    }
    return <GenderSelection onSelectGender={handleSelectGender} />;
  };

  return <Layout>{renderEntry()}</Layout>;
};

export default HomePage;
